import './LayerManagers.css';
import React, { useEffect, useState } from 'react';
import { OrderList } from 'primereact/orderlist';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import ImageWMS from 'ol/source/ImageWMS';
import nolegend from '../../_assets/img/no-legend.png';
import { ServerTypeHelper } from '../../_config/helpers';
import { Tooltip } from 'primereact/tooltip';
import { useTranslation } from 'react-i18next';

function LayerManager({ map }) {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [visible, setVisible] = useState(true);

  const collapsedLeft = 5;

  const getSidebarWidth = () => {
    return window.innerWidth <= 1280 ? 290 : 320;
  };


  useEffect(() => {
    const handleResize = () => setSidebarWidth(getSidebarWidth());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [sidebarWidth, setSidebarWidth] = useState(getSidebarWidth());


  const ignoredIds = ['6', '10'];
  const ignoredTitles = [
    'imagem de satélite', 'ruas', 'híbrido: imagem de satélite e ruas',
    'esri', 'mapa topográfico', 'mapa global', 'logradouros',
    'open street maps', 'vias', 'csv', 'camada 1', 'camada 2', 'camada 4', 'grade', 'Mapa escuro', 'Mapa global claro'
  ];

  const layerEnable = 'Limites Municipais (IPECE_2021)';

  const loadVisibleLayers = () => {
    if (!map) return;

    const visibleLayers = map.getLayers().getArray()
      .filter(layer => layer.getVisible())
      .map((layer, index) => ({
        id: String(layer.get('id') ?? layer.ol_uid ?? index),
        title: (layer.get('title') ?? layer.get('name') ?? `Camada ${index}`).trim(),
        layer,
        zIndex: layer.getZIndex() ?? index
      }))
      .filter(l =>
        !ignoredTitles.map(t => t.toLowerCase()).includes(l.title.toLowerCase()) &&
        !ignoredIds.includes(l.id)
      )
      .sort((a, b) => a.zIndex - b.zIndex);

    setItems(visibleLayers);
  };

  useEffect(() => {
    loadVisibleLayers();
    if (!map) return;

    map.getLayers().getArray().forEach(layer =>
      layer.on('change:visible', loadVisibleLayers)
    );
  }, [map]);

  const applyZIndex = (list) => {
    const maxZ = Math.max(...list.map(i => i.layer.getZIndex() ?? 0));

    list.forEach((item, index) => {
      const newZ = maxZ - index;
      item.layer.setZIndex(newZ);
      item.zIndex = newZ;
    });
  };

  const onReorder = (event) => {
    const reordered = event.value;
    if (!reordered?.length) return;

    applyZIndex(reordered);
    setItems([...reordered]);
  };

  const getLegendUrl = (layer) => {
    if (!layer || !layer.getVisible()) return nolegend;

    if (layer.get('serverType') === ServerTypeHelper.GEOSERVER) {
      const source = new ImageWMS({
        url: layer.get('url'),
        params: { LAYERS: layer.get('wmsName'), TRANSPARENT: true },
        serverType: 'geoserver'
      });

      return source.getLegendUrl(map.getView().getResolution(),
        {
          legend_options: 'fontColor:#FFFFFF;fontSize:9',
          transparent: 'true'
        });
    }

    return nolegend;
  };

  const itemTemplate = (item) => {

    const header = (
      <span className="LegendTitle">{t(item.title)}</span>
    );

    const icons =
      item.title !== layerEnable ? (
        <Button
          icon="pi pi-times"
          className="p-button-rounded p-button-text p-button-danger"
          tooltip="Desativar camada"
          tooltipOptions={{ position: 'top' }}
          onClick={(e) => {
            e.stopPropagation();

            if (items.length === 1) {
              setVisible(false);
            }

            item.layer.setVisible(false);
          }}
        />
      ) : null;



    return (
      <Panel
        header={header}
        icons={icons}
        toggleable
        className="LegendPanel"
      >
        <div className="ContainerImgInput">
          <div className="LegendImageWrapper">
            <img
              src={getLegendUrl(item.layer)}
              alt="Legenda"
              className="PopUpLayerLegend"
            />
          </div>
        </div>

        <div className="containerOpacity">
          <label>Opacidade: </label>
          <input
            type="range"
            className="LayerOpacity"
            min="0"
            max="1"
            step="0.01"
            defaultValue={item.layer.getOpacity()}
            onInput={e =>
              item.layer.setOpacity(parseFloat(e.target.value))
            }
            onMouseDown={e => e.stopPropagation()}
            onTouchStart={e => e.stopPropagation()}
          />
        </div>
      </Panel>
    );
  };



  return (
    <>
      <Button
        icon={visible ? 'pi pi-angle-left' : 'pi pi-angle-right'}
        className={`BtnSideBarLegend ${visible ? 'open' : 'closed'}`}
        style={{
          left: visible ? `${sidebarWidth}px` : `${collapsedLeft}px`
        }}
        onClick={() => setVisible(!visible)}
      />

      <Sidebar
        visible={visible}
        position="left"
        className="SideBarLegend"
        showCloseIcon={false}
        modal={false}
        dismissable={false}
        blockScroll={false}
        onHide={() => { }}
      >
        <h5>{t('legendPopup.title')}</h5>
        <hr />

        <OrderList
          value={items}
          onChange={onReorder}
          itemTemplate={itemTemplate}
          className="ListaLegenda"
        />
      </Sidebar>
    </>
  );
}

export default LayerManager;
